(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('.product__image--main img');
        this.addEventListener('click', this.onThumbnailClick.bind(this));
      }

      onThumbnailClick(event) {
        const button = event.target.closest('.product__thumbnail');
        if (!button || !this.mainImage) return;

        this.mainImage.removeAttribute('srcset');
        this.mainImage.removeAttribute('sizes');
        this.mainImage.src = button.dataset.fullSrc;
        this.mainImage.alt = button.dataset.alt || '';

        this.querySelectorAll('.product__thumbnail').forEach((thumbnail) => {
          const isActive = thumbnail === button;
          thumbnail.classList.toggle('product__thumbnail--active', isActive);
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateSubtotal(root) {
    const select = root.querySelector('.product__variant-select');
    const qtyInput = root.querySelector('.product__quantity-input');
    const subtotalEl = root.querySelector('.product__subtotal-amount');
    if (!qtyInput || !subtotalEl) return;

    let unitPriceCents;
    if (select) {
      const selectedOption = select.options[select.selectedIndex];
      unitPriceCents = selectedOption ? parseInt(selectedOption.dataset.priceCents, 10) : null;
    } else {
      unitPriceCents = parseInt(qtyInput.dataset.unitPriceCents, 10);
    }

    const quantity = parseInt(qtyInput.value, 10) || 1;
    if (!unitPriceCents) return;

    subtotalEl.textContent = formatMoney(unitPriceCents * quantity);
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.product__variant-select')) {
      const select = event.target;
      const info = select.closest('.product__info');
      const priceEl = info ? info.querySelector('.product__price') : null;
      const selectedOption = select.options[select.selectedIndex];
      const price = selectedOption ? selectedOption.dataset.price : null;

      if (priceEl && price) {
        priceEl.innerHTML = '<span>' + price + '</span>';
      }

      const layout = select.closest('.product__layout');
      const mainImage = layout ? layout.querySelector('.product__image--main') : null;
      const newSrc = selectedOption ? selectedOption.dataset.image : '';
      if (mainImage && newSrc) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = newSrc;
        mainImage.alt = (selectedOption && selectedOption.dataset.alt) || mainImage.alt;
      }

      if (info) updateSubtotal(info);
    }
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('.product__quantity-input')) {
      const info = event.target.closest('.product__info');
      if (info) updateSubtotal(info);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('.product__image--main img');
        this.addEventListener('click', this.onThumbnailClick.bind(this));
      }

      onThumbnailClick(event) {
        const button = event.target.closest('.product__thumbnail');
        if (!button || !this.mainImage) return;

        this.mainImage.removeAttribute('srcset');
        this.mainImage.removeAttribute('sizes');
        this.mainImage.src = button.dataset.fullSrc;
        this.mainImage.alt = button.dataset.alt || '';

        this.querySelectorAll('.product__thumbnail').forEach((thumbnail) => {
          const isActive = thumbnail === button;
          thumbnail.classList.toggle('product__thumbnail--active', isActive);
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateSubtotal(root) {
    const select = root.querySelector('.product__variant-select');
    const qtyInput = root.querySelector('.product__quantity-input');
    const subtotalEl = root.querySelector('.product__subtotal-amount');
    if (!qtyInput || !subtotalEl) return;

    let unitPriceCents;
    if (select) {
      const selectedOption = select.options[select.selectedIndex];
      unitPriceCents = selectedOption ? parseInt(selectedOption.dataset.priceCents, 10) : null;
    } else {
      unitPriceCents = parseInt(qtyInput.dataset.unitPriceCents, 10);
    }

    const quantity = parseInt(qtyInput.value, 10) || 1;
    if (!unitPriceCents) return;

    subtotalEl.textContent = formatMoney(unitPriceCents * quantity);
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.product__variant-select')) {
      const select = event.target;
      const info = select.closest('.product__info');
      const priceEl = info ? info.querySelector('.product__price') : null;
      const selectedOption = select.options[select.selectedIndex];
      const price = selectedOption ? selectedOption.dataset.price : null;

      if (priceEl && price) {
        priceEl.innerHTML = '<span>' + price + '</span>';
      }

      const layout = select.closest('.product__layout');
      const mainImage = layout ? layout.querySelector('.product__image--main') : null;
      const newSrc = selectedOption ? selectedOption.dataset.image : '';
      if (mainImage && newSrc) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = newSrc;
        mainImage.alt = (selectedOption && selectedOption.dataset.alt) || mainImage.alt;
      }

      if (info) updateSubtotal(info);
    }
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('.product__quantity-input')) {
      const info = event.target.closest('.product__info');
      if (info) updateSubtotal(info);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
